module.exports = __webpack_public_path__ + "static/media/logo_amazing_menu.46dcb0e5.png";